import { motion } from "framer-motion";
import { Play, Phone, ArrowRight } from "lucide-react";

export const ComingSoon = () => {
  return (
    <section id="coming-soon" data-testid="coming-soon-section" className="grain-overlay bg-[#081C15] text-white py-20 md:py-28 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="order-2 lg:order-1"
        >
          <p className="font-display text-xs font-bold uppercase tracking-[0.25em] text-[#D4AF37] mb-4">Coming Soon</p>
          <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight" data-testid="coming-soon-heading">
            Something cleaner is on the way
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#D8E2DC] leading-relaxed">
            We're rolling out across British Columbia — watch the teaser, then be one of the
            first producers to book professional barn cleaning and sanitation with IMR.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <a
              href="tel:+19709023321"
              data-testid="coming-soon-call"
              className="inline-flex items-center gap-2.5 rounded-full bg-[#D4AF37] text-[#081C15] px-7 py-3.5 font-display font-bold text-sm hover:brightness-110 transition duration-200 shadow-[0_4px_24px_rgba(212,175,55,0.35)]"
            >
              <Phone size={17} />
              Call 1-970-902-3321
            </a>
            <a
              href="#contact"
              data-testid="coming-soon-quote"
              className="inline-flex items-center gap-2.5 rounded-full border-2 border-white/25 text-white px-7 py-3.5 font-display font-bold text-sm hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-200"
            >
              Request Service Info
              <ArrowRight size={17} />
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: "easeOut" }}
          className="order-1 lg:order-2 flex justify-center"
        >
          <div className="relative">
            <div className="absolute -inset-3 bg-[#D4AF37]/15 rounded-3xl rotate-2" aria-hidden="true" />
            <video
              src="/imr-promo-teaser.mp4"
              data-testid="coming-soon-video"
              className="relative rounded-2xl w-full max-w-[300px] shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
              autoPlay
              muted
              loop
              playsInline
              controls
            />
            <span className="absolute -top-3 -right-3 bg-[#D4AF37] text-[#081C15] font-display font-black text-xs uppercase tracking-[0.15em] px-4 py-2 rounded-full shadow-lg rotate-3 inline-flex items-center gap-1.5">
              <Play size={12} />
              Watch
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
